module.exports = __webpack_public_path__ + "img/lachsteller.50da88c4.png";